/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Arakan examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import { Tooltip, IconButton, Icon, Grid } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FilterIcon from "@mui/icons-material/Money";

import CrudService from "services/cruds-service";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import { Can } from "Can";
import { subject } from "@casl/ability";
import AuthService from "services/auth-service";
import i18n from "i18n";
import CsvDownloadButton from "react-json-to-csv";

import FilterUser from "./filter-user";
import CustomerCell from "components/table/CustomerCell";
import DefaultCell from "components/table/DefaultCell";
import StatusCell from "components/table/StatusCell";
import { Add, FilterAlt, Mail, PauseCircle, Search } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import MailComposerDialog from "components/MailComposerDialog";

function UserManagement() {
  let { state, pathname } = useLocation();
  const { t } = i18n;
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [sortVal, setSortVal] = useState(null);
  const [sortUrl, setSortUrl] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [userInfo, setUserInfo] = useState(false);
  const [user, setUsers] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [limitChange, setLimitChange] = useState(false);
  let route = pathname.split("/")[pathname.split("/").length - 1];

  // donators

  const [filterUrl, setFilterUrl] = useState(null);
  const [defaultFilterUrl, setDefaultFilterUrl] = useState("");
  // const [open, setOpen] = useState(false);
  // const [mailSubject, setSubject] = useState("");
  // const [mailBody, setBody] = useState("");
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const baseUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);

  const [tableData, setTableData] = useState([]);

  const getUsers = async (filUrl) => {
    let URL = filUrl ? `${filUrl}&page=${page}` : `&page=${page}`;

    if (route === "donators")
      URL += "&filter[role][_eq]=222e841a-1ee9-482d-a8da-129cdb7fc05d";
    else if (route === "influencers")
      URL += "&filter[role][_eq]=0476f14d-84d3-44e3-a9d0-735e97e33cf5";
    else
      URL += `&filter[_and][1][_or][1]filter[role][_nin]=0476f14d-84d3-44e3-a9d0-735e97e33cf5,222e841a-1ee9-482d-a8da-129cdb7fc05d&filter[_and][1][_or][2][role][_null]=true`;
    // "&filter[role][_nin]=0476f14d-84d3-44e3-a9d0-735e97e33cf5,222e841a-1ee9-482d-a8da-129cdb7fc05d";

    const response = await CrudService.getData(
      `users?fields=*,role.name,role.id${URL}`,
    );

    setUsers(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    (async () => {
      const { data } = await AuthService.getProfile();
      setIsAdmin(
        data.role?.name === "Administrator" || data.role?.name === "admins",
      );
      setUserInfo(true);
      if (data.role?.name !== "Administrator") {
        setFilterUrl(filterUrl || "");
        setDefaultFilterUrl();
      } else getUsers();
    })();
  }, [pathname]);

  useEffect(() => {
    userInfo && getUsers(`${filterUrl || ""}${sortUrl}`);
  }, [page]);

  useEffect(() => {
    userInfo && getUsers(`${filterUrl || ""}${sortUrl}`);
    setLimitChange(false);
  }, [limitChange]);

  useEffect(() => {
    if (sortVal) {
      setSortUrl(
        `&sort=${sortVal.desc ? "-" : "+"}${
          sortVal.id === "name" ? "first_name" : sortVal.id
        }`,
      );
    }
  }, [sortVal]);

  // useEffect(() => {
  //   if (sortVal) {
  //     setFilterUrl(
  //       `${filterUrl || ""}${sortUrl}`
  //     );
  //   }
  // }, [sortUrl]);

  useEffect(() => {
    if (userInfo && page === 1) getUsers(`${filterUrl || ""}${sortUrl}`);
    else if (userInfo && page !== 1) setPage(1);
  }, [filterUrl, sortUrl]);

  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    setTableData(getRows(user));
  }, [user]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const clickAddHandler = () => {
    navigate(`/userManagement/addUser/${route}`);
  };

  const clickEditHandler = (id) => {
    navigate(`/userManagement/updateUser/${route}/${id}`);
  };

  // const updateStatusHandler = async (e, data) => {
  //   let obj;
  //   if (data.status === "active") obj = { status: "suspended" };
  //   else obj = { status: "active" };
  //   await CrudService.updateUser(obj, data.id);
  //   getUsers(`${filterUrl || ""}${sortUrl}`);
  //   setNotification({
  //     value: true,
  //     text: t("statusChanged"),
  //   });
  // };

  const clickDeleteHandler = async (e, obj) => {
    try {
      if (!window.confirm(t("confirmDelete"))) {
        e.nativeEvent.stopImmediatePropagation();
      } else if (obj.total_donations_count > 0 || obj.total_donations > 0) {
        setNotification({
          value: true,
          color: "error",
          text: "لا يمكن حذف المستخدم لوجود تبرعات له",
        });
      } else {
        await CrudService.deleteUser(obj.id);
        // the delete does not send a response
        // so I need to get again the tags to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
        getUsers(filterUrl);
        setNotification({
          value: true,
          color: "success",
          text: "تم الحذف بنجاح",
        });
      }
    } catch (err) {
      // it sends error is the category is associated with an item
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          color: "error",
          text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
        });
      }
      return null;
    }
  };

  // const clickSuspendAllHandler = async (e, id) => {
  //   try {
  //     const ids = user.map((item) => item.id);
  //     await CrudService.updateSomeUser(ids, {
  //       status: "suspended",
  //     });
  //     getUsers(filterUrl);
  //     setNotification({
  //       value: true,
  //       color: "success",
  //       text: "تم الحفظ بنجاح",
  //     });
  //   } catch (err) {
  //     // it sends error is the category is associated with an item
  //     console.error(err);
  //     if (err.hasOwnProperty("errors")) {
  //       setNotification({
  //         value: true,
  //         color: "error",
  //         text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
  //       });
  //     }
  //     return null;
  //   }
  // };

  // const sendEmail = async () => {
  //   try {
  //     const emails = user.map((item) => item.email);
  //     await CrudService.createItem(`api/mail`, {
  //       emails,
  //       mailSubject,
  //       mailBody,
  //     });
  //     console.log(emails, mailSubject, mailBody);
  //     setOpen(false);
  //     setNotification({
  //       value: true,
  //       color: "success",
  //       text: "تم الإرسال بنجاح",
  //     });
  //   } catch (err) {
  //     // it sends error is the category is associated with an item
  //     console.error(err);
  //     if (err.hasOwnProperty("errors")) {
  //       setNotification({
  //         value: true,
  //         color: "error",
  //         text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
  //       });
  //     }
  //     return null;
  //   }
  // };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      let roleName = row.role?.name;
      return {
        ...row,
        name: `${row.first_name} ${row.last_name}`,
        image: row.avatar ? `${baseUrl}assets/${row.avatar}` : null,
        role: roleName,
        customer: [
          `${row.first_name} ${row.last_name}`,
          {
            image: row.avatar ? `${baseUrl}assets/${row.avatar}` : null,
          },
        ],
      };
    });
    return updatedInfo;
  };

  const getCsvRows = (info) => {
    let updatedInfo = info.map((row) => {
      let roleName = row.role?.name;
      let csv = {
        id: row.id,
        name: `${row.first_name} ${row.last_name}`,
        email: row.email,
        role: roleName,
        status: row.status,
      };
      const keys = Object.keys(csv);
      let csvObj = {};
      keys.forEach((element) => {
        csvObj[t(element)] = csv[element];
      });
      return csvObj;
    });
    return updatedInfo;
  };

  const setFilterTxt = (txt) => {
    const filter = txt
      ? `&filter[_or][1][first_name][_contains]=${txt}&filter[_or][2][last_name][_contains]=${txt}&filter[_or][3][email][_contains]=${txt}`
      : null;
    filter ? setFilterUrl(filter) : getUsers("");
  };

  const dataTableData = {
    columns: [
      {
        Header: t("id"),
        accessor: "id",
        width: "15%",
        hidden: false,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("users"),
        accessor: "customer",
        Cell: ({ value: [name, data] }) => (
          <CustomerCell
            image={data.image}
            color={data.color || "dark"}
            name={name}
          />
        ),
      },
      {
        Header: t("status"),
        accessor: "status",
        width: "15%",
        // hidden: true,
        Cell: ({ value }) => {
          let status;

          if (value === "active") {
            status = <StatusCell icon="done" color="success" status={value} />;
          } else {
            status = <StatusCell icon="close" color="error" status={value} />;
          }

          return status;
        },
      },
      {
        Header: t("lang"),
        accessor: "lang",
        width: "15%",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("email"),
        accessor: "email",
        width: "20%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("phone"),
        accessor: "phone",
        width: "20%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("country"),
        accessor: "country",
        width: "20%",
        hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "عدد التبرعات",
        accessor: "total_donations_count",
        width: "15%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "إجمالي مبلغ التبرعات",
        accessor: "total_donations",
        width: "15%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: t("role"),
        accessor: "role",
        width: "15%",
        disableSortBy: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        hidden: false,
        Header: t("actions"),
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {isAdmin ? (
                <>
                  {/* <MDButton
                    onClick={(e) =>
                      clickDeleteHandler(e, info.cell.row.original.id)
                    }
                    variant="outlined"
                    color={"error"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1 }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                  </MDButton> */}

                  <MDButton
                    onClick={(e) =>
                      navigate(
                        `/donationManagement/donations/filter/&filter[user_id][id][_eq]=${info.cell.row.original.id}`,
                      )
                    }
                    variant="outlined"
                    color={"secondary"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>volunteer_activism</Icon>
                    &nbsp;
                    <Tooltip title="إدارة التبرعات">
                      <span> إدارة التبرعات</span>
                    </Tooltip>
                  </MDButton>
                  <MDButton
                    onClick={() => clickEditHandler(info.cell.row.original.id)}
                    variant="outlined"
                    color={"info"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                    &nbsp;
                    <Tooltip title="فتح للتعديل">
                      <span> فتح للتعديل </span>
                    </Tooltip>
                  </MDButton>
                  {/* <Can
                    I="delete"
                    this={subject("users", info.cell.row.original)}
                  > */}
                  <MDButton
                    onClick={(e) =>
                      clickDeleteHandler(e, info.cell.row.original)
                    }
                    variant="outlined"
                    color={"error"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                    &nbsp;
                    <Tooltip title=" حذف المستخدم">
                      <span> حذف المستخدم </span>
                    </Tooltip>
                  </MDButton>
                  {/* </Can> */}
                </>
              ) : (
                <>
                  <Can
                    I="delete"
                    this={subject("users", info.cell.row.original)}
                  >
                    <MDButton
                      onClick={(e) =>
                        clickDeleteHandler(e, info.cell.row.original)
                      }
                      variant="outlined"
                      color={"error"}
                      size="medium"
                      iconOnly
                      sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                    </MDButton>
                  </Can>
                  <Can I="edit" this={subject("users", info.cell.row.original)}>
                    <MDButton
                      onClick={() =>
                        clickEditHandler(info.cell.row.original.id)
                      }
                      variant="outlined"
                      color={"success"}
                      size="medium"
                      iconOnly
                      sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                      &nbsp;
                      <Tooltip title="فتح للتعديل">
                        <span> فتح للتعديل </span>
                      </Tooltip>
                    </MDButton>
                  </Can>
                </>
              )}
            </MDBox>
          );
        },
      },
      ,
    ],
    rows: tableData,
  };

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      {notification.value && (
        <MDAlert color={notification.color} my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox pt={3} pb={3}>
        <MDBox mb={3}>
          <Card sx={{ mb: 1 }}>
            <MDBox
              p={3}
              lineHeight={1}
              display="flex"
              justifyContent="space-between"
            >
              <MDTypography variant="h5" fontWeight="medium" color="info">
                {t(route)}
              </MDTypography>
              <MDBox display="flex">
                {(ability.can("create", "users") || isAdmin) && (
                  // <IconButton size="large" onClick={clickAddHandler}>
                  //   <Add color="info" />
                  // </IconButton>
                  <MDButton
                    onClick={clickAddHandler}
                    variant="outlined"
                    color={"info"}
                    size="medium"
                    iconOnly
                    sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;
                    <Tooltip title=" إضافة عضو جديد">
                      <span>إضافة عضو جديد </span>
                    </Tooltip>
                  </MDButton>
                )}
                {(ability.can("delete", "users") || isAdmin) && (
                  <MailComposerDialog
                    users={user}
                    setNotification={setNotification}
                  />
                )}
                {/* <IconButton
                  size="large"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <Search color="info" />
                </IconButton> */}
                {isAdmin && (
                  // <CsvDownloadButton
                  //   // sx={{ mx: 1 }}
                  //   data={getCsvRows(user)}
                  //   style={{
                  //     backgroundColor: "white",
                  //     color: colors.info.main,
                  //     borderColor: "white",
                  //     borderWidth: 0,
                  //     fontSize: "25px",
                  //     fontWeight: "bold",
                  //     padding: "12px ",
                  //     marginLeft: "1px",
                  //   }}
                  // >
                  //   <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                  // </CsvDownloadButton>
                  <CsvDownloadButton
                    data={getCsvRows(user)}
                    style={{
                      backgroundColor: "white",
                      color: colors.info.main,
                      borderColor: "#FF5528",
                      borderWidth: 1,
                      fontSize: "16px",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      width: "auto",
                      padding: "8px 12px",
                      marginRight: "8px",
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                    &nbsp;
                    <Tooltip title="تصدير">
                      <span> تصدير </span>
                    </Tooltip>
                  </CsvDownloadButton>
                )}
              </MDBox>
            </MDBox>
          </Card>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={showFilter ? 9.5 : 12}>
              <DataTable
                canAddCol={true}
                canSearch={true}
                filterTxt={setFilterTxt}
                setLimitChange={setLimitChange}
                table={dataTableData}
                meta={meta}
                setPage={setPage}
                setSortVal={setSortVal}
                pageNum={page}
              />
            </Grid>
            {/* {showFilter && (
              <Grid item xs={12} lg={2.5}>
                <Card>
                  <FilterUser
                    setFilterUrl={setFilterUrl}
                    filterUrl={defaultFilterUrl}
                  />
                </Card>
              </Grid>
            )} */}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserManagement;
